<template>
  <Primitive
    :as="as"
    :class="cn(iconButtonVariants({ variant, size }), $attrs.class ?? '')"
  >
    <slot />
  </Primitive>
</template>

<script setup>
import { Primitive } from 'radix-vue';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils.js';

defineProps({
  variant: {
    type: String,
    default: 'primary',
  },
  size: {
    type: String,
    default: 'default',
  },
  as: {
    type: String,
    default: 'button',
  },
});

const iconButtonVariants = cva(
  [
    'relative inline-flex items-center justify-center rounded ring-offset-background transition-colors overflow-hidden',
    'text-sm font-semibold',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
    'before:rounded before:absolute before:inset-0 before:transition-opacity before:bg-black before:opacity-0',
    'hover:before:opacity-[0.08] active:before:opacity-[0.12] data-[state=open]:before:opacity-[0.12]',
    'disabled:pointer-events-none disabled:opacity-50',
  ],
  {
    variants: {
      variant: {
        primary: 'bg-accent-400 text-neutral-900 hover:text-neutral-900',
        tonal: 'bg-accent-200 text-neutral-900 hover:text-neutral-900',
        danger: 'bg-error-400 text-neutral-900',
        secondary:
          'bg-secondary-600 text-neutral-50 before:bg-neutral-300 active:before:opacity-[0.12]',
        outline:
          'border border-primary-400 bg-background text-neutral-300 before:bg-neutral-300 active:before:opacity-[0.12]',
        link: 'text-accent-400 hover:bg-transparent hover:before:opacity-0 active:before:opacity-0',
        ghost:
          'text-neutral-300 before:bg-neutral-300 active:before:opacity-[0.12]',
      },
      size: {
        default: 'size-10',
        sm: 'size-8 px-2',
        micro: 'size-6 px-1',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default',
    },
  }
);
</script>
